var app = angular.module('leonardo');

var WorkFlowService = function(BaseRestService, RestangularProvider, $filter) {
  var service = new BaseRestService('workflows', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('workflows', false, function(workflow) {
      workflow.addRestangularMethod('activate', 'post', 'activate');
      workflow.addRestangularMethod('checkActivate', 'post', 'check-active-workflow');
      return workflow;
    });
  });
  service.approvalWorkflowList = function() {
    return RestangularProvider.all('workflows').customGET('approval-workflow-list');
  };
  service.triggerWorkflowList = function(id, params) {
    return RestangularProvider.one('workflows', id).customGET('trigger-workflow-list', params);
  };
  service.activate = function(id, values) {
    return RestangularProvider.one('workflows', id).customPOST(values, 'activate');
  };
  service.massLaunchWorkflows = function(values) {
    return RestangularProvider.one('workflows').customPOST(values, 'mass-launch-workflows');
  };
  service.countSelectedUnits = function(id, values) {
    return RestangularProvider.one('workflows', id).customPOST(values, 'count-selected-units');
  };
  service.multiPropertyCountSelectedUnits = function(id, values) {
    return RestangularProvider.one('workflows').customPOST(values, 'multi-property-count-selected-units');
  };
  service.toggleRecurrence = function (id, values) {
    return RestangularProvider.one('workflows/' + id + '/enable-recurrence').patch(values);
  }

  service.WORFLOW_MOVE_IN = '1';
  service.WORFLOW_PRE_MOVE_IN = '2';
  service.WORFLOW_MOVE_OUT = '3';
  service.WORFLOW_MAKE_READY = '4';

  service.IS_UNIT_TURN_OPTIONS = [
    { id: false, name: $filter('translate')('Standard') },
    { id: true, name: $filter('translate')('Unit turn') }
  ];

  service.UNIT_TURN_WORKFLOW_OPTIONS = [
    { id: service.WORFLOW_MOVE_IN, name: $filter('translate')('Move In') },
    { id: service.WORFLOW_PRE_MOVE_IN, name: $filter('translate')('Pre Move Out') },
    { id: service.WORFLOW_MOVE_OUT, name: $filter('translate')('Move Out') },
    { id: service.WORFLOW_MAKE_READY, name: $filter('translate')('Make Ready') }
  ];

  return service;
};

app.factory('WorkFlowService', ['BaseRestService', 'Restangular', '$filter', WorkFlowService]);